import { Badge } from '@wundo/ui';
import { useOpenUrgentReviewCount } from '@/lib/useOpenUrgentReviewCount.ts';
import type { NavItem } from './navConfig.ts';

/** A page's name in the navigation, with its count beside it when it carries one. */
export function NavItemLabel({ item }: { item: NavItem }) {
  if (!item.badge) return <>{item.label}</>;

  return (
    <span className='flex min-w-0 flex-1 items-center justify-between gap-2'>
      <span className='truncate'>{item.label}</span>
      <OpenUrgentReviewsBadge />
    </span>
  );
}

/* Rendered only where the Reviews page is on offer, so only staff ever ask for the count. */
function OpenUrgentReviewsBadge() {
  const count = useOpenUrgentReviewCount();
  if (count === 0) return null;

  return (
    <Badge tone='danger'>
      {count}
      <span className='sr-only'> urgent open</span>
    </Badge>
  );
}
